import { useTranslation } from 'react-i18next';

import floralSkirt from '../../assets/floral-skirt.png';
import floralTop from '../../assets/floral-top.png';

export function UpsellStrategy() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Personalization.components.ShopTheLook',
  });

  return (
    <div className="overflow-hidden rounded-lg border bg-white shadow-sm">
      <h3 className="border-b p-4 text-lg font-medium">{t('upsellTitle')}</h3>

      <div className="p-4">
        <div className="mb-4 rounded-lg border border-gray-200 p-4">
          <h3 className="mb-4 text-xl font-bold">{t('completeTheLook')}</h3>
          <div className="mb-4 grid grid-cols-2 gap-4">
            <div className="rounded-lg border bg-white p-1">
              <div className="mb-2 flex justify-center rounded-lg p-3">
                <img
                  src={floralTop}
                  alt="Floral pattern top"
                  className="h-auto w-[200px] rounded-lg"
                />
              </div>

              <div className="h-[120px] rounded-lg bg-white p-4">
                <h4 className="text-sm font-medium">{t('product1Title')}</h4>

                <div className="mt-1 flex items-baseline">
                  <span className="text-sm font-medium">
                    {t('product1Price')}
                  </span>
                  <span className="ml-1 text-xs text-gray-500">
                    {t('product1Installments')}
                  </span>
                </div>
              </div>
            </div>

            <div className="rounded-lg border border-gray-200 bg-white p-1">
              <div className="mb-2 flex justify-center rounded-lg p-3">
                <img
                  src={floralSkirt}
                  alt="Floral pattern skirt"
                  className="h-auto w-[200px] rounded-lg"
                />
              </div>

              <div className="h-[120px] rounded-lg bg-white p-4">
                <h4 className="text-sm font-medium">{t('product2Title')}</h4>

                <div className="mt-1 flex items-baseline">
                  <span className="text-sm font-medium">
                    {t('product2Price')}
                  </span>
                  <span className="ml-1 text-xs text-gray-500">
                    {t('product2Installments')}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-3 flex items-center justify-between">
            <span className="font-medium">{t('totalValueLabel')}</span>
            <div>
              <span className="font-medium">{t('totalValuePrice')}</span>
              <span className="ml-1 text-xs text-gray-500">
                {t('totalValueInstallments')}
              </span>
            </div>
          </div>

          <button className="w-full rounded-full bg-gray-900 py-3 font-medium text-white">
            {t('ctaButton')}
          </button>
        </div>

        <p className="mb-2 text-sm text-gray-600">{t('upsellNote')}</p>
      </div>
    </div>
  );
}
